import * as types from 'constants/actionTypes'
import { Theme } from 'declarations/app'

export const setTheme = (theme: Theme) => ({
  type: types.THEME_SET,
  payload: { theme }
})
